import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
    providedIn: 'root'
})

/**
 * Auth Guard
 */
export class AuthGuard implements CanActivate {
    
    path: ActivatedRouteSnapshot[] | undefined;
    route: ActivatedRouteSnapshot | undefined;

    /**
     * Constructor
     * @param {Router} router
     * @param {LocalStorageService} localStorage
     */
    constructor(private localStorage: LocalStorageService, private router: Router) {
    }

    /**
     * Redirige a la pagina de login en caso de que el usuario no
     * este logueado.
     *
     * @return true si el usuario esta logueado, falso en caso contrario
     */
    canActivate(): boolean {
        // Si el usuario no esta logueado se le redirigira a la pagina de login
        if (!this.localStorage.loadData('access_token')) {
            this.router.navigate(['/auth/login']);
            return false;
        }
        return true;
    }
}
